// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "@firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDfrvTlAHuPNbtB9WGBJpwDMszoYDf140o",
  authDomain: "igis-web.firebaseapp.com",
  projectId: "igis-web",
  storageBucket: "igis-web.appspot.com",
  messagingSenderId: "456189682289",
  appId: "1:456189682289:web:860cc3772faabde35cb1d0",
  measurementId: "G-E5DQ88T4PM",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const auth = getAuth(app);

export const storage = getStorage(app);
